import { render, staticRenderFns } from "./VentanaModificarTPV.vue?vue&type=template&id=0070b4c3&scoped=true&"
import script from "./VentanaModificarTPV.vue?vue&type=script&lang=js&"
export * from "./VentanaModificarTPV.vue?vue&type=script&lang=js&"
import style0 from "./VentanaModificarTPV.vue?vue&type=style&index=0&id=0070b4c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0070b4c3",
  null
  
)

export default component.exports